<div *ngIf="pledgeCampaign; else loading">
  <div
    class="mb-10 mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-between mct-items-center mct-justify-center-lt-sm mct-items-center-lt-sm"
  >
    <span class="pledge-campaign-header">{{ pledgeCampaign.CampaignName }}</span>
    <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-12">
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="cancel()">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
      <button
        class="atlas-btn atlas-btn-primary"
        *wlAccessControl="{ SecurityElement: securityElementNames.Revenue_Module, MinimumAccessLevel: 2 }"
        [disabled]="!detailsForm.dirty || !detailsForm.valid"
        (click)="detailsForm.ngSubmit.emit()"
      >
        <span *ngIf="!isSaving">{{ 'common.save' | translate | uppercase }}</span>
        <wl-busy *ngIf="isSaving" [show]="true"></wl-busy>
      </button>
    </div>
  </div>
  <div class="mb-17 mct-flex mct-row mct-justify-end mct-items-stretch">
    <action-button [label]="actionsText" [items]="actionsOptions"> </action-button>
  </div>
  <div class="tabs-wrapper">
    <wlx-tabs>
      <wlx-tab [title]="'revenue.pledge-campaigns.pledge-campaign.edit.title' | translate | titlecase">
        <form #detailsForm="ngForm" (ngSubmit)="save()">
          <wl-pledge-campaign-details-edit [pledgeCampaign]="pledgeCampaign"></wl-pledge-campaign-details-edit>
          <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-12">
            <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="cancel()">
              {{ 'common.cancel' | translate | uppercase }}
            </button>
            <button
              *wlAccessControl="{ SecurityElement: securityElementNames.Revenue_Module, MinimumAccessLevel: 2 }"
              type="submit"
              class="atlas-btn atlas-btn-primary"
              [disabled]="!detailsForm.dirty || !detailsForm.valid"
            >
              <span *ngIf="!isSaving">{{ 'common.save' | translate | uppercase }}</span>
              <wl-busy *ngIf="isSaving" [show]="true"></wl-busy>
            </button>
          </div>
        </form>
      </wlx-tab>
      <wlx-tab [title]="'revenue.pledge-campaigns.pledge-campaign.pledges.title' | translate | titlecase">
        <wl-pledge-campaign-pledges
          [pledgeCampaign]="pledgeCampaign"
          (pledgeDeleted)="reloadProgressBarComponent($event)"
        ></wl-pledge-campaign-pledges>
      </wlx-tab>
    </wlx-tabs>
  </div>
</div>

<ng-template #loading>
  <div class="mct-flex mct-row mct-justify-center mct-items-center">
    <wl-busy [show]="true" [isLarge]="true"></wl-busy>
  </div>
</ng-template>
